<template>
  <span>
    <a
      class="btn btn-v-lightgreen-white pull-right"
      :class="{ 'is-disabled': organizationId == null }"
      href="/customers/customerId/merge/"
      v-tooltip="{
        content: $label(
          'organization.merge_organizations',
          'Merge organizations'
        ),
        classes: 'custom-tooltip'
      }"
    >
      <i class="fa fa-fw fa-lg fa-compress"></i>
    </a>
    <a
      class="btn btn-v-lightgreen-white pull-right"
      :class="{ 'is-disabled': organizationId == null }"
      href="/customers/customerId/journal/view/"
      v-tooltip="{
        content: $label('organization.note', 'Note'),
        classes: 'custom-tooltip'
      }"
    >
      <i class="fa fa-fw fa-lg fa-pencil"></i>
    </a>
    <a
      class="btn btn-v-lightgreen-white pull-right"
      :class="{ 'is-disabled': organizationId == null }"
      href="/customers/customerId/message/sms/"
      v-tooltip="{
        content: $label('organization.sms', 'SMS'),
        classes: 'custom-tooltip'
      }"
    >
      <i class="fa fa-fw fa-lg fa-mobile"></i>
    </a>
    <a
      class="btn btn-v-lightgreen-white pull-right"
      :class="{ 'is-disabled': organizationId == null }"
      href="/customers/customerId/message/email/"
      v-tooltip="{
        content: $label('organization.email', 'Email'),
        classes: 'custom-tooltip'
      }"
    >
      <i class="fa fa-fw fa-lg fa-envelope-o"></i>
    </a>
    <a
      class="btn btn-v-lightgreen-white pull-right"
      :class="{ 'is-disabled': organizationId == null }"
      href="/courses/booking/customer/customerId"
      v-tooltip="{
        content: $label('organization.book_course', 'Book course'),
        classes: 'custom-tooltip'
      }"
    >
      <i class="fa fa-fw fa-lg fa-user-plus"></i>
    </a>
  </span>
</template>

<script>
export default {
  name: "OrganizationActions",

  props: ["organizationId"]
};
</script>

<style scoped></style>
